import { MenuItem } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const StyledMenuItem = styled(MenuItem, {})({
  '&:hover': {
    backgroundColor: `${theme.palette.fontgrey}33`,
  },
  '&.Mui-selected': {
    backgroundColor: `${theme.palette.fontgrey}11`,
    '&:hover': {
      backgroundColor: `${theme.palette.fontgrey}33`,
    },
  },
});
